var _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 19.9993C20.9205 19.9993 21.6667 19.2532 21.6667 18.3327C21.6667 17.4122 20.9205 16.666 20 16.666C19.0795 16.666 18.3333 17.4122 18.3333 18.3327C18.3333 19.2532 19.0795 19.9993 20 19.9993Z",
    fill: "#E87A46"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6667 19.9993C27.5871 19.9993 28.3333 19.2532 28.3333 18.3327C28.3333 17.4122 27.5871 16.666 26.6667 16.666C25.7462 16.666 25 17.4122 25 18.3327C25 19.2532 25.7462 19.9993 26.6667 19.9993Z",
    fill: "#E87A46"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 19.9993C14.2538 19.9993 15 19.2532 15 18.3327C15 17.4122 14.2538 16.666 13.3333 16.666C12.4129 16.666 11.6667 17.4122 11.6667 18.3327C11.6667 19.2532 12.4129 19.9993 13.3333 19.9993Z",
    fill: "#E87A46"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6667 5H8.33333C7.00725 5 5.73548 5.52678 4.7978 6.46447C3.86012 7.40215 3.33333 8.67392 3.33333 10V35C3.33384 35.2953 3.41281 35.5852 3.56217 35.84C3.71152 36.0948 3.92589 36.3053 4.18333 36.45C4.43242 36.5912 4.71368 36.6658 5 36.6667C5.29914 36.6666 5.59274 36.586 5.85 36.4333L13.3333 31.9C13.6099 31.7353 13.9283 31.6543 14.25 31.6667H31.6667C32.9927 31.6667 34.2645 31.1399 35.2022 30.2022C36.1399 29.2645 36.6667 27.9927 36.6667 26.6667V10C36.6667 8.67392 36.1399 7.40215 35.2022 6.46447C34.2645 5.52678 32.9927 5 31.6667 5ZM33.9881 27.3215C33.9881 27.7635 33.8125 28.1874 33.5 28.5C33.1874 28.8126 32.7635 28.9882 32.3214 28.9882L14.25 29C13.3397 28.9993 12.4465 29.2471 11.6667 29.7167L5.85 33.5V9.19036C5.85 8.74833 6.02559 8.3244 6.33815 8.01184C6.65071 7.69928 7.07464 7.52369 7.51667 7.52369L32.3214 7.51184C32.7635 7.51184 33.1874 7.68744 33.5 8C33.8125 8.31256 33.9881 8.73648 33.9881 9.17851V27.3215Z",
    fill: "url(#paint0_linear_720_4030)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_720_4030",
    x1: 36.6667,
    y1: 20.8334,
    x2: 3.33333,
    y2: 20.8334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B225F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E40E41"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/Message.d0280cd7b47b8aabd0269fec440101db.svg";
export { ForwardRef as ReactComponent };